import { LockPercentOpenVariantIcon } from './LockPercentOpenVariantIcon';

/**
 * author: mocking-mike
 * id 4F6E68BA-D1BA-4AD7-AA6D-A80E04CC2D6F
 * name lock-percent-open-variant
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-percent-open-variant.svg
 * tags
 */
export const LockRateOpenVariantIcon = LockPercentOpenVariantIcon;
export default LockRateOpenVariantIcon